import type { EventName } from "@lit/react";
import { TextField as TextFieldElement, type TextFieldEventMap as _TextFieldEventMap, } from "@vaadin/text-field/vaadin-text-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TextFieldElement, };
export type TextFieldEventMap = Readonly<{
    onValidated: EventName<_TextFieldEventMap["validated"]>;
    onChange: EventName<_TextFieldEventMap["change"]>;
    onInput: EventName<_TextFieldEventMap["input"]>;
    onInvalidChanged: EventName<_TextFieldEventMap["invalid-changed"]>;
    onValueChanged: EventName<_TextFieldEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as TextFieldEventMap;
export type TextFieldProps = WebComponentProps<TextFieldElement, TextFieldEventMap>;
export const TextField = createComponent({
    elementClass: TextFieldElement, events, react: React, tagName: "vaadin-text-field"
});
